import * as types from '../constants/actionTypes';

const initialState = {
  config: null,
  pendingApprovals: [],
  // poApprovalStatuses keyed by poId
  poApprovalStatuses: {},
  loading: false,
  actionLoading: false,
  configLoading: false,
  error: null,
};

const approvalReducer = (state = initialState, action) => {
  switch (action.type) {
    // ── Config ────────────────────────────────────────────────────────────────
    case types.FETCH_APPROVAL_CONFIG_REQUEST:
      return { ...state, configLoading: true, error: null };
    case types.FETCH_APPROVAL_CONFIG_SUCCESS:
      return { ...state, configLoading: false, config: action.payload };
    case types.FETCH_APPROVAL_CONFIG_FAILURE:
      return { ...state, configLoading: false, error: action.payload };

    case types.UPDATE_APPROVAL_CONFIG_REQUEST:
      return { ...state, configLoading: true, error: null };
    case types.UPDATE_APPROVAL_CONFIG_SUCCESS:
      return { ...state, configLoading: false, config: action.payload };
    case types.UPDATE_APPROVAL_CONFIG_FAILURE:
      return { ...state, configLoading: false, error: action.payload };

    // ── Pending Approvals ─────────────────────────────────────────────────────
    case types.FETCH_PENDING_APPROVALS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PENDING_APPROVALS_SUCCESS:
      return { ...state, loading: false, pendingApprovals: action.payload || [] };
    case types.FETCH_PENDING_APPROVALS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // ── PO Approval Status ────────────────────────────────────────────────────
    case types.FETCH_PO_APPROVAL_STATUS_REQUEST:
      return { ...state, loading: true };
    case types.FETCH_PO_APPROVAL_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        poApprovalStatuses: {
          ...state.poApprovalStatuses,
          [action.payload.poId]: action.payload.data,
        },
      };
    case types.FETCH_PO_APPROVAL_STATUS_FAILURE:
      return { ...state, loading: false };

    // ── Approve / Reject ──────────────────────────────────────────────────────
    case types.APPROVE_PO_REQUEST:
    case types.REJECT_PO_APPROVAL_REQUEST:
      return { ...state, actionLoading: true, error: null };

    case types.APPROVE_PO_SUCCESS: {
      const updated = action.payload;
      const poId = updated?.purchase_order_id;
      const filtered = state.pendingApprovals.filter(
        (r) => r.purchase_order_id !== poId
      );
      return {
        ...state,
        actionLoading: false,
        pendingApprovals: filtered,
        poApprovalStatuses: poId
          ? { ...state.poApprovalStatuses, [poId]: updated }
          : state.poApprovalStatuses,
      };
    }

    case types.REJECT_PO_APPROVAL_SUCCESS: {
      const updated = action.payload;
      const poId = updated?.purchase_order_id;
      const filtered = state.pendingApprovals.filter(
        (r) => r.purchase_order_id !== poId
      );
      return {
        ...state,
        actionLoading: false,
        pendingApprovals: filtered,
        poApprovalStatuses: poId
          ? { ...state.poApprovalStatuses, [poId]: updated }
          : state.poApprovalStatuses,
      };
    }

    case types.APPROVE_PO_FAILURE:
    case types.REJECT_PO_APPROVAL_FAILURE:
      return { ...state, actionLoading: false, error: action.payload };

    case types.CLEAR_APPROVAL_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
};

export default approvalReducer;
